import { MenuItem } from '@mui/material';
import moment from 'moment';
import React from 'react';
import isEqual from 'react-fast-compare';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import { connect, ConnectedProps } from 'react-redux';
import { getSplitBreaks } from '../../libs/lessonSplit';
import { LESSON_FILTERS } from '../../resources/constants';
import { decimalToTime } from '../../resources/utils';
import axiosapi from '../../store/actions/axiosapi';
import { ApplicationState } from '../../store/types';
import {
    EndTime,
    LessonDetail,
    Level,
    MeetingPoint,
    Time
} from '../../types/booking';
import BookingLessonDetails from './bookingLessonDetails';

type ReduxProps = ConnectedProps<typeof connector>;

interface IProps {
    lessonDetail: LessonDetail;
    currentLevel: Level;
    isCheckAvailabilityLoading: boolean;
    onClickSelect(state: State): void;
}

type Props = IProps & WrappedComponentProps & ReduxProps;

interface State {
    days: number;
    startDate: string;
    endDate: string;
    infoDays: string;
    infoBeginDays: string;
    infoEndDays: string;
    infoNumberDaysMin: string;
    infoNumberDaysMax: string;
    participants: string;
    price: number;
    times: any;
    meetingPoints: MeetingPoint[];
    endTimes: EndTime[];
    nbMinutes: number;
    startTimesOption: any;
    endTimesOption: any;
    meetingPointsOption: any;
    hours: {
        hoursLesson: number;
        totalHoursLesson: number;
    };
    selectedEndTimeIndex: number;
    selectedStartTimeIndex: number;
    selectedMeetingPointIndex: number;
}

class GroupLessonDetail extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        const { lessonDetail } = this.props;

        let meetingPointIndexTemp;

        if (lessonDetail.meetingPoints.length > 1) {
            meetingPointIndexTemp = -1;
        } else if (lessonDetail.meetingPoints.length === 1) {
            meetingPointIndexTemp = 0;
        } else {
            meetingPointIndexTemp = -2;
        }

        this.state = {
            days: lessonDetail.nb_days,
            startDate: lessonDetail.startDate,
            endDate: lessonDetail.endDate,
            infoDays: lessonDetail.info_days,
            infoBeginDays: lessonDetail.info_begin_days,
            infoEndDays: lessonDetail.info_end_days,
            infoNumberDaysMin: lessonDetail.info_number_days_min,
            infoNumberDaysMax: lessonDetail.info_number_days_max,
            participants: lessonDetail.participants,
            price: lessonDetail.price,
            times: lessonDetail.times,
            meetingPoints: lessonDetail.meetingPoints,
            endTimes: lessonDetail.times[0].endTimes,
            nbMinutes: lessonDetail.nb_minutes,
            startTimesOption: [],
            endTimesOption: [],
            meetingPointsOption: [],
            hours: {
                hoursLesson: 0,
                totalHoursLesson: 0
            },
            selectedEndTimeIndex: GroupLessonDetail.getEarliestEndTimeIndex(lessonDetail.times[0].endTimes),
            selectedStartTimeIndex: GroupLessonDetail.getEarliestStartTimeIndex(lessonDetail.times),
            selectedMeetingPointIndex: meetingPointIndexTemp,
        };

        this.handleChangeStartTime = this.handleChangeStartTime.bind(this);
        this.handleChangeEndTime = this.handleChangeEndTime.bind(this);
        this.handleChangeMeetingPoint = this.handleChangeMeetingPoint.bind(this);
        this.handleClickButtonSelect = this.handleClickButtonSelect.bind(this);
        this.calculatingTotalHoursLesson = this.calculatingTotalHoursLesson.bind(this);
    }

    componentDidMount() {
        this.setState((state) => ({
            startTimesOption: this.formatStartTimesOptions(state.times),
            endTimesOption: this.formatEndTimesOptions(state.endTimes),
            meetingPointsOption: this.formatMeetingPointsOptions(),
            hours: this.calculatingTotalHoursLesson(),
        }), () => {
            this.getNewPrice();
        });
    }

    componentDidUpdate(prevProps: Readonly<Props>): void {
        const { lessonDetail } = this.props;
        if (!isEqual(prevProps.lessonDetail, lessonDetail)) {
            let meetingPointIndexTemp;

            if (lessonDetail.meetingPoints.length > 1) {
                meetingPointIndexTemp = -1;
            } else if (lessonDetail.meetingPoints.length === 1) {
                meetingPointIndexTemp = 0;
            } else {
                meetingPointIndexTemp = -2;
            }

            this.setState({
                days: lessonDetail.nb_days,
                startDate: lessonDetail.startDate,
                endDate: lessonDetail.endDate,
                infoDays: lessonDetail.info_days,
                infoBeginDays: lessonDetail.info_begin_days,
                infoEndDays: lessonDetail.info_end_days,
                infoNumberDaysMin: lessonDetail.info_number_days_min,
                infoNumberDaysMax: lessonDetail.info_number_days_max,
                participants: lessonDetail.participants,
                price: lessonDetail.price,
                times: lessonDetail.times,
                meetingPoints: lessonDetail.meetingPoints,
                endTimes: lessonDetail.times[0].endTimes,
                nbMinutes: lessonDetail.nb_minutes,
                startTimesOption: [],
                endTimesOption: [],
                meetingPointsOption: [],
                hours: {
                    hoursLesson: 0,
                    totalHoursLesson: 0
                },
                selectedEndTimeIndex: GroupLessonDetail.getEarliestEndTimeIndex(lessonDetail.times[0].endTimes),
                selectedStartTimeIndex: GroupLessonDetail.getEarliestStartTimeIndex(lessonDetail.times),
                selectedMeetingPointIndex: meetingPointIndexTemp,
            }, () => {
                this.setState((state) => ({
                    startTimesOption: this.formatStartTimesOptions(state.times),
                    endTimesOption: this.formatEndTimesOptions(state.endTimes),
                    meetingPointsOption: this.formatMeetingPointsOptions(),
                    hours: this.calculatingTotalHoursLesson(),
                }), () => {
                    this.getNewPrice();
                });
            });
        } else if (!isEqual(prevProps.currentLevel, this.props.currentLevel)) {
            this.getNewPrice();
        }
    }

    handleChangeStartTime(event: any) {
        const timeSetIndex = parseInt(event.target.value, 10);

        // set price to -1 to activate spinner
        this.setState((state) => ({
            selectedStartTimeIndex: timeSetIndex,
            selectedEndTimeIndex: GroupLessonDetail.getEarliestEndTimeIndex(state.times[timeSetIndex].endTimes),
            endTimesOption: this.formatEndTimesOptions(state.times[timeSetIndex].endTimes),
            endTimes: state.times[timeSetIndex].endTimes,
            price: -1,
        }), () => {
            this.getNewPrice();
            this.setState({ hours: this.calculatingTotalHoursLesson() });
        });
    }

    handleChangeEndTime(event: any) {
        // set price to -1 to activate spinner
        this.setState({
            selectedEndTimeIndex: parseInt(event.target.value, 10),
            price: -1,
        }, () => {
            this.getNewPrice();
            this.setState({ hours: this.calculatingTotalHoursLesson() });
        });
    }

    handleChangeMeetingPoint(event: any) {
        this.setState({ selectedMeetingPointIndex: parseInt(event.target.value, 10) });
    }

    handleClickButtonSelect() {
        const { onClickSelect } = this.props;
        onClickSelect(this.state);
    }

    getNewPrice() {
        const { currentLesson, currentLevel } = this.props;
        const {
            times,
            selectedEndTimeIndex,
            selectedStartTimeIndex,
            startDate,
            endDate,
            days,
            participants,
        } = this.state;
        const startTime = moment(times[selectedStartTimeIndex].startTime).format('[0001-01-01T]HH:mm:ss');
        const endTime = moment(times[selectedStartTimeIndex].endTimes[selectedEndTimeIndex].time).format('[0001-01-01T]HH:mm:ss');

        const body = {
            lessonId: currentLesson?.id,
            levelId: currentLevel.id,
            fromDate: startDate,
            toDate: endDate,
            startTime,
            endTime, // TODO: confirm utility of endTime??
            nbDays: days,
            nbParticipants: participants,
        };

        axiosapi.post('/booking-corner/price/', body)
            .then((response) => {
                this.setState({ price: response.data === 'price_undefined' ? -2 : response.data });
            })
            .catch(() => this.setState({ price: -2 }));
    }

    // Get the index of the earliest start time (the one that should be displayed first)
    static getEarliestStartTimeIndex(times: Time[]): number {
        if (!times || times.length === 0) return 0;

        let earliestIndex = 0;
        let earliestTime = moment(times[0].startTime);

        times.forEach((time, index) => {
            const currentTime = moment(time.startTime);
            if (currentTime.isBefore(earliestTime)) {
                earliestTime = currentTime;
                earliestIndex = index;
            }
        });

        return earliestIndex;
    }

    // Get the index of the earliest end time (the one that should be displayed first)
    static getEarliestEndTimeIndex(endTimes: EndTime[]): number {
        if (!endTimes || endTimes.length === 0) return 0;

        let earliestIndex = 0;
        let earliestTime = moment(endTimes[0].time);

        endTimes.forEach((time, index) => {
            const currentTime = moment(time.time);
            if (currentTime.isBefore(earliestTime)) {
                earliestTime = currentTime;
                earliestIndex = index;
            }
        });

        return earliestIndex;
    }

    calculatingTotalHoursLesson() {
        const { lessonDetail } = this.props;
        const {
            times: timesState, selectedStartTimeIndex, selectedEndTimeIndex, days, endTimes,
        } = this.state;
        const { startTime } = timesState[selectedStartTimeIndex];
        const endTime = endTimes[selectedEndTimeIndex].time;

        let calculatedHours = 0;

        // try to get split time (lunch break)
        try {
            const periods = lessonDetail.times[selectedStartTimeIndex].endTimes[selectedEndTimeIndex].split.split(' + ');
            for (const period of periods) {
                const times = period.split('-');
                calculatedHours += moment(times[1], 'HH:mm').diff(moment(times[0], 'HH:mm'), 'hours', true);
            }
        } catch (error) {
            calculatedHours = moment(endTime).diff(startTime, 'hours', true);
        }

        const hours = {
            hoursLesson: calculatedHours,
            totalHoursLesson: (calculatedHours * days),
        };

        return hours;
    }

    // TODO : Refactor => unified this tree methods format options
    formatStartTimesOptions(times: Time[]) {
        const { intl } = this.props;

        // Create array with original indices
        const timesWithIndex = times.map((time, index) => ({ time, originalIndex: index }));

        // Sort by time in ascending order (earliest to latest)
        timesWithIndex.sort((a, b) => {
            const timeA = moment(a.time.startTime);
            const timeB = moment(b.time.startTime);
            return timeA.diff(timeB); // Ascending order: earliest first
        });

        // Map to MenuItems using original index as value
        return timesWithIndex.map(({ time, originalIndex }) => {
            const startTime = moment(time.startTime).format(`HH[${intl.formatMessage({ id: 'booking.h' })}]mm`);
            return (<MenuItem key={`start_times_${originalIndex}`} value={originalIndex}>{startTime}</MenuItem>);
        });
    }

    formatEndTimesOptions(endTimes: EndTime[]) {
        const { intl } = this.props;

        // Create array with original indices
        const endTimesWithIndex = endTimes.map((time, index) => ({ time, originalIndex: index }));

        // Sort by time in ascending order (earliest to latest)
        endTimesWithIndex.sort((a, b) => {
            const timeA = moment(a.time.time);
            const timeB = moment(b.time.time);
            return timeA.diff(timeB); // Ascending order: earliest first
        });

        // Map to MenuItems using original index as value
        return endTimesWithIndex.map(({ time, originalIndex }) => {
            const endTime = moment(time.time).format(`HH[${intl.formatMessage({ id: 'booking.h' })}]mm`);
            return (<MenuItem key={`end_times_${originalIndex}`} value={originalIndex}>{endTime}</MenuItem>);
        });
    }

    formatMeetingPointsOptions() {
        const { meetingPoints } = this.state;
        const { intl } = this.props;
        const meetingPointsTmp = meetingPoints.map((meeting, i) => {
            const idx = i;
            return (<MenuItem key={`meeting${idx}`} value={idx}>{meeting.name}</MenuItem>);
        });
        if (meetingPointsTmp.length > 1) meetingPointsTmp.unshift(<MenuItem key="meeting-disabled" value={-1} disabled>{intl.formatMessage({ id: 'booking.meetingSmall' })}</MenuItem>);
        return meetingPointsTmp;
    }

    render() {
        const {
            days,
            meetingPointsOption,
            startDate,
            endDate,
            times,
            endTimes,
            selectedEndTimeIndex,
            infoDays,
            infoBeginDays,
            infoEndDays,
            infoNumberDaysMax,
            infoNumberDaysMin,
            hours,
            participants,
            startTimesOption,
            endTimesOption,
            meetingPoints,
            price,
            selectedMeetingPointIndex,
            selectedStartTimeIndex,
        } = this.state;
        const {
            intl, currentLesson, currentLevel, isCheckAvailabilityLoading,
        } = this.props;
        const startDateTmp = moment(startDate).format('DD.MM.YYYY');
        const endDateTmp = moment(endDate).format('DD.MM.YYYY');

        const splitBreaks = getSplitBreaks(endTimes?.[selectedEndTimeIndex]?.split);

        return (
            currentLesson
                ? (
                    <BookingLessonDetails
                        lesson={{
                            id: currentLesson.id,
                            type: LESSON_FILTERS.GROUP_LESSON,

                            // Period card
                            startDate: startDateTmp,
                            endDate: endDateTmp,
                            infoDays,
                            infoBeginDays,
                            infoEndDays,
                            infoNumberDaysMin,
                            infoNumberDaysMax,

                            // Hours card - Both start and end time for group lessons
                            startTimeLabel: intl.formatMessage({ id: 'booking.startTime' }),
                            startTimeValues: times.map((t: any) => t.startTime),
                            startTimeOptions: startTimesOption,
                            selectedStartTimeIndex,
                            onStartTimeChange: this.handleChangeStartTime,

                            endTimeLabel: intl.formatMessage({ id: 'booking.endTime' }),
                            endTimeValues: endTimes.map((t) => t.time),
                            endTimeOptions: endTimesOption,
                            selectedEndTimeIndex,
                            onEndTimeChange: this.handleChangeEndTime,

                            splitBreaks,

                            // Summary card
                            numberOfDays: days,
                            lessonDuration: decimalToTime(hours.hoursLesson, intl.formatMessage, false),
                            totalHours: decimalToTime(hours.totalHoursLesson, intl.formatMessage, false),

                            // Other
                            level: currentLevel,
                            participants,
                            meetingPoints,
                            meetingPointOptions: meetingPointsOption,
                            selectedMeetingPointIndex,
                            onMeetingPointChange: this.handleChangeMeetingPoint,
                            price,
                        }}
                        handleClickButtonSelect={this.handleClickButtonSelect}
                        isCheckAvailabilityLoading={isCheckAvailabilityLoading}
                    />
                )
                : null

        );
    }
}

const mapStateToProps = (store: ApplicationState) => ({
    currentLesson: store.booking.currentLesson,
});

const connector = connect(mapStateToProps);

export default injectIntl(connector(GroupLessonDetail));
